<template>
  <tr>
    <td>
      <router-link
        :to="{
          name: 'single-customer-group',
          params: { id: props.item.id }
        }"
      >
        {{ props.item.code }}
      </router-link>
    </td>
    <td class="text-xs-left">
      {{ props.item.name }}
    </td>
  </tr>
</template>
<script>
export default {
  name: 'CustomerGroupDataTableRow',

  props: {
    props: {
      type: Object,
      required: true
    }
  }
}
</script>
